import React from 'react';
import Linker from '../../linker/Linker'
import * as path from '../../../../route/PathConfig'

import './NoticeMain.css';

const NoticePageMain = (props) => {

  return (
    <div className="row featured-main">
      <div className="NoticeTitle">
        <span className="nielsen-navyBlack">{props.noticeData.title}</span>
        <div id="NoticeSearchBtn">
          <Linker path={`${path.NOTICE}`}>
            <a className="button purple_line" style={{dispaly:"inline-block"}}>목록</a>
          </Linker>
          {props.userRole == 'ROLE_ADMIN' ?
            <a className="button purple_line" onClick={()=>props.handleDeleteBtn(props.noticeData.noticeID)} style={{dispaly:"inline-block"}}>삭제</a>
            :undefined
          }
        </div>
      </div>
      <div style={{maginTop: "20px"}} dangerouslySetInnerHTML={{__html: props.noticeData.content}}></div>
    </div>
  )
}

export default NoticePageMain;